const DatetimeConstants = {
  DatetimeFormat: 'YYYY-MM-DD HH:mm:ss',
  TimeFormat: 'HH:mm',
  DateFormat: 'YYYY-MM-DD'
}

export default DatetimeConstants
